import React, {useRef} from "react";
import { Screen } from '~common/screen';
import { StyledScreen } from '~common/screen';
import { Styled } from './styled';
import Slider from "react-slick";
import QuoteIcon from '~images/quote-icon.svg'
import NextArrow from '~images/slider-next-arrow.svg'
import { AmplitudeCounter } from "~/amplitude-counter";

const ReviewsScreen = () => {
  const sliderRef = useRef(null)

  const reviews = [
    {
      text: 'Отличный сервис. Хорошая связь никаких проблем нет. Интеграция работает четко, звонки все передаются, можно прослушать. Интуитивно понятный и легко настраиваемый интерфейс. Если что-то не понятно, то грамотная тех. поддержка всегда на связи. Единственный сервис который помог быстро решить вопрос с интеграцией виртуальных номеров билайн. Пользуемся сервисом больше года, все супер!',
      name: 'Балтин Александр Юрьевич',
      date: '25.12.2020'
    },
    {
      text: 'Обожаю техподдержку Pbx! Почему именно? А вот почему: 1. Всегда быстро вникают в то что от них требуется. 2. Не пытаются переложить на плечи своих партнеров решение проблем. 3. Можно быстро дозвониться (а это очень важно). 4. Подробно описывают каким именно образом решили возникшую ситуацию и рассказывают, как избежать данных неприятностей в будущем. Ребята спасибо от всего нашего коллектива!',
      name: 'Сабинина Татьяна',
      date: '04.02.2021'
    },
    {
      text: 'Все четко сделано. Являюсь владельцем онлайн-школы английского языка. Год пользуемся, никаких нареканий. Поэтому кто рассматривает для себя телефонию для онлайн-школы - рекомендую. Техподдержка супер, связь супер, интеграция с Амо супер. Всем успехов!',
      name: 'РОП',
      date: '25.12.2020'
    },
    {
      text: 'Используем ОнлайнPBX в АмоСРМ уже года три.. Отлично работают! Оплата проходит моментально и активация мгновенная. Были у нас случаи когда "отваливался" ОнлайнPBX от АМО- но оказалось по вине нашего провайдера.. мы в таких случаях звонили в Техподдержку ОнлайнPBX ( звонится прямо с АМО - нужно набрать 000.. всегда отвечают.. Техподдержка - работает на ОтличнО!!!) Смело рекомендую!',
      name: 'Альтаир Мохорев',
      date: '10.02.2021'
    },
    {
      text: 'Ребята молодцы, для небольшой компании - то, что надо. Отличный сервис по хорошей цене. Очень радует, как работает техподдержка - отвечают быстро и всегда помогают.',
      name: 'Василий Анисимов',
      date: '27.01.2021'
    },
    {
      text: 'Отличный сервис, отличная поддержка. Ломала голову над отчетами, чтобы разгрузить менеджеров - предложили решение за 1 минуту. На счет обновления - были страхи, что все полетит или не будет работать - но все прошло хорошо, без косяков, да и интерфейс радует. Спасибо!',
      name: 'Администратор',
      date: '20.01.2021'
    }
  ]

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    useCSS: true,
    adaptiveHeight: true,
    appendDots: (dots: any) => (
      <Styled.Dots>
        <ul style={{ margin: "0px" }}> {dots} </ul>
      </Styled.Dots>
    ),
    customPaging: (i: number) => (
      <Styled.Dot />
    ),
    afterChange: () => AmplitudeCounter('view_feadback_onlinepbx')
  };

  const next = () => {
    if (sliderRef) sliderRef.current.slickNext()
  }

  return (
    <Screen
      title={<span><StyledScreen.GreenText>Техподдержка,</StyledScreen.GreenText> которой не все равно</span>}
      bottomLine={true}
    >
      <Styled.Container>
        <Styled.Slider>
          <Slider ref={sliderRef} { ...sliderSettings }>
            {
              reviews.map(review => (
                <Styled.Slide>
                  <Styled.Quote><QuoteIcon /></Styled.Quote>
                  <Styled.SlideInner>
                    <Styled.SlideText>{review.text}</Styled.SlideText>
                    <Styled.SlideFooter>
                      <Styled.Author>{review.name}</Styled.Author>
                      <Styled.Date>{review.date}</Styled.Date>
                    </Styled.SlideFooter>
                  </Styled.SlideInner>
                </Styled.Slide>
              ))
            }
          </Slider>
          <Styled.Next onClick={next}><NextArrow /></Styled.Next>
        </Styled.Slider>
      </Styled.Container>
    </Screen>
  )
}

export { ReviewsScreen }